export default __webpack_public_path__ + "Brandon_bld.otf";